module.exports = __webpack_public_path__ + "img/No_active.f040311b.png";